const state = {
  download_banner: [],
};

export default state;
